import FlightStatus from '../../schema/innerSchema/FlightStatus';

/**
 * Returns FlightStatus based on the value of the input
 * Returns null if the expected input is not given
 */
export default function getFlightStatus(flightStatus: string): FlightStatus {
    switch (flightStatus) {
        case 'Active':
            return FlightStatus.Active;

        case 'Scheduled':
            return FlightStatus.Scheduled;

        case 'Landed':
            return FlightStatus.Landed;

        case 'Diverted':
            return FlightStatus.Diverted;

        case 'Redirected':
            return FlightStatus.Redirected;

        case 'Cancelled':
            return FlightStatus.Cancelled;

        case 'NotOperational':
            return FlightStatus.NotOperational;

        case 'Unknown':
            return FlightStatus.Unknown;

        default:
            return null;
    }
}
